import { Guest } from '@/app/system/guest/Guest';
import { PatronPool } from '@/app/system/guest/PatronPool';

export class Loading implements Guest<boolean> {
  private theLoading = false;
  private loadingPool = new PatronPool<boolean>(this);

  public loading<R extends Guest<boolean>>(guest: R): R {
    this.loadingPool.distributeReceivingOnce(this.theLoading, guest);
    return guest;
  }

  introduction() {
    return 'guest' as const;
  }

  receive(value: boolean): this {
    this.theLoading = value;
    this.loadingPool.receive(value);
    return this;
  }
}
